<script setup lang="ts">
import type { GradeCode } from '~/models/Grade'
import type { ContentTermExam } from '~/models/Content/ContentTermExam'
import type { ContentProductHeader } from '~/models/Content/ContentProductHeader'
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import useAuthStore from '~/stores/auth'
import UpcomingExams from '~/components/products/exams/UpcomingExams.vue'
import ExamsShared from '~/components/products/exams/ExamsShared.vue'
import ExamsOld from '~/components/products/exams/ExamsOld.vue'
import ExamsNew from '~/components/products/exams/ExamsNew.vue'

const {
  oldTermExams,
  newTermExams,
  selectedGrades,
  isLoading
} = defineProps<{
  oldTermExams: ContentProductHeader[]
  newTermExams?: ContentTermExam
  selectedGrades: GradeCode[]
  isLoading: boolean
}>()

const { userOrganization, isTeacher } = storeToRefs(useAuthStore())

const localOrganizations = [
  'NO456326497', // Aschehoug Grunnskole 1 (Nye Lokus testskole)
  'NO456326498', // Aschehoug Grunnskole 2 (Nye Lokus testskole)
  'NO910292005', // Aschehoug grunnskole 3
  'NO971660082', // Aschehoug grunnskole 3
  'NO971744987', // Aschehoug grunnskole 4
]

const isLocalUser = computed(() => userOrganization.value && localOrganizations.includes(userOrganization.value.number))
const isUnderConstruction = computed(() => newTermExams && newTermExams.underConstruction)
const isExamAvailable = computed(() => !isUnderConstruction.value || isLocalUser.value)
</script>

<template>
  <div class="grid-in-results space-y-10">
    <ExamsShared
      :selected-grades="selectedGrades"
    />
    <ExamsNew
      v-if="isTeacher && isExamAvailable"
      :exams="newTermExams"
      :selected-grades="selectedGrades"
      :is-loading
    />
    <UpcomingExams
      v-else-if="isTeacher"
      :exams="newTermExams"
    />
    <ExamsOld
      v-if="oldTermExams.length"
      :exams="oldTermExams"
      :selected-grades="selectedGrades"
      :is-loading
    />
  </div>
</template>
